export interface Size {
  name: string;
  equivalence: number | { from: number; to: number };
  waist: { from: number; to: number };
  hip: { from: number; to: number };
}

const sizes: Size[] = [
  {
    name: "xs",
    equivalence: 34,
    waist: {
      from: 55,
      to: 59,
    },
    hip: {
      from: 84,
      to: 88,
    },
  },
  {
    name: "s",
    equivalence: 36,
    waist: {
      from: 59,
      to: 63,
    },
    hip: {
      from: 88,
      to: 92,
    },
  },
  {
    name: "m",
    equivalence: 38,
    waist: {
      from: 63,
      to: 67,
    },
    hip: {
      from: 92,
      to: 96,
    },
  },
  {
    name: "l",
    equivalence: { from: 40, to: 42 },
    waist: {
      from: 67,
      to: 71,
    },
    hip: {
      from: 96,
      to: 102,
    },
  },
  {
    name: "xl",
    equivalence: 44,
    waist: {
      from: 71,
      to: 75,
    },
    hip: {
      from: 102,
      to: 108,
    },
  },
  {
    name: "xxl",
    equivalence: { from: 46, to: 48 },
    waist: {
      from: 75,
      to: 79,
    },
    hip: {
      from: 108,
      to: 114,
    },
  },
  {
    name: "3xl",
    equivalence: { from: 50, to: 52 },
    waist: {
      from: 79,
      to: 83,
    },
    hip: {
      from: 114,
      to: 120,
    },
  },
];

export default sizes;
